var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loadingInit)?_c('div',{class:_vm.isRTL ? 'ArFont' : 'EnFont',attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }